(() => {
  const initDreamHighFooterHeader = () => {
    const footer = document.querySelector('footer.dh-footer');
    const headerSection = document.querySelector('.header-section');

    if (!footer || !headerSection || headerSection.dataset.dhiFooterHeaderBound === 'true') return;

    headerSection.dataset.dhiFooterHeaderBound = 'true';
    headerSection.classList.add('dhi-footer-fade-ready');

    const closingTarget = footer;
    let closingZoneVisible = false;

    const isHeaderInteractionOpen = () => {
      return headerSection.classList.contains('is-active') || Boolean(headerSection.querySelector('.is-active'));
    };

    const syncHeaderVisibility = () => {
      const shouldHide = closingZoneVisible && !isHeaderInteractionOpen();
      const isHidden = headerSection.classList.contains('dhi-footer-header-hidden');

      if (shouldHide !== isHidden) {
        headerSection.classList.toggle('dhi-footer-header-hidden', shouldHide);
      }
    };

    const closingObserver = new IntersectionObserver(
      (entries) => {
        closingZoneVisible = entries[0].isIntersecting;
        syncHeaderVisibility();
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -12% 0px'
      }
    );

    closingObserver.observe(closingTarget);

    const headerInteractionObserver = new MutationObserver(() => {
      syncHeaderVisibility();
    });

    headerInteractionObserver.observe(headerSection, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDreamHighFooterHeader, { once: true });
  } else {
    initDreamHighFooterHeader();
  }
})();

/* DREAM HIGH — GLOBAL FINAL FOOTER FRAME
   Mobile/tablet only. The closing viewport is always footer + Between Us, on every page. */
(() => {
  const initGlobalFooterFrame = () => {
    const footer = document.querySelector('footer.dh-footer');
    if (!footer || footer.dataset.dhiGlobalFrameBound === 'true') return;

    const html = document.documentElement;
    const body = document.body;
    const touchViewport = window.matchMedia('(max-width: 1024px) and (any-pointer: coarse)');
    const lockedReference =
      body.classList.contains('template-suffix-founders-privilege') ||
      (body.classList.contains('template-collection') && window.location.pathname === '/collections/all');
    footer.dataset.dhiGlobalFrameBound = 'true';

    let closingZoneVisible = false;
    let lastY = window.scrollY || 0;
    let direction = 0;
    let snapTimer = 0;
    let snapInFlight = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncVisibleViewport = () => {
      if (!touchViewport.matches) {
        html.style.removeProperty('--dhi-footer-visible-h');
        return;
      }
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      if (viewportHeight > 0) {
        html.style.setProperty('--dhi-footer-visible-h', `${Math.round(viewportHeight)}px`);
      }
    };

    const visibleHeight = () => window.visualViewport?.height || window.innerHeight;

    const footerGeometry = () => {
      const rect = footer.getBoundingClientRect();
      const viewport = visibleHeight();
      const absoluteTop = (window.scrollY || 0) + rect.top;
      const strictThreshold = Math.max(0, absoluteTop - viewport * 0.92);
      return {
        rect,
        viewport,
        absoluteTop,
        strictThreshold,
        visible: rect.top < viewport && rect.bottom > 0,
        approaching: rect.top > 1 && rect.top < viewport * 0.92,
        remainingPageApproaching: (window.scrollY || 0) >= strictThreshold && rect.top > 1
      };
    };

    const anyMobileColumnOpen = () =>
      window.matchMedia('(max-width: 599px)').matches &&
      Boolean(footer.querySelector('.dh-footer__column[open]'));

    const syncFrameState = () => {
      const geometry = footerGeometry();
      const active = touchViewport.matches && (closingZoneVisible || geometry.visible);
      const expanded = touchViewport.matches && anyMobileColumnOpen();

      footer.classList.toggle('dhi-footer-expanded', expanded);
      html.classList.toggle('dhi-global-footer-frame', active);
      html.classList.toggle('dhi-global-footer-snap-armed', active && !expanded);
    };

    const snapToClosingFrame = () => {
      // Keep the footer frame visual, but never force scroll position on touch devices.
      return;
      if (!touchViewport.matches || anyMobileColumnOpen() || snapInFlight) return;
      if (direction <= 0) return;

      const geometry = footerGeometry();
      const shouldSnap = lockedReference ? geometry.approaching : geometry.remainingPageApproaching;
      if (!shouldSnap) return;

      closingZoneVisible = true;
      syncFrameState();

      snapInFlight = true;
      footer.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });

      window.requestAnimationFrame(() => {
        const correction = footer.getBoundingClientRect().top;
        if (Math.abs(correction) > 1) {
          window.scrollTo({
            top: Math.max(0, Math.round((window.scrollY || 0) + correction)),
            behavior: 'auto'
          });
        }
        syncFrameState();
      });

      window.clearTimeout(snapTimer);
      snapTimer = window.setTimeout(() => {
        snapInFlight = false;
      }, 120);
    };

    const queueClosingSnap = () => {
      // Preserve natural bidirectional swiping without a queued footer snap.
      return;
      window.clearTimeout(snapTimer);
      snapTimer = window.setTimeout(snapToClosingFrame, 20);
    };

    const trackDirection = () => {
      const y = window.scrollY || 0;
      if (y > lastY + 1) direction = 1;
      else if (y < lastY - 1) direction = -1;
      lastY = y;

      const geometry = footerGeometry();
      const shouldQueue = lockedReference ? geometry.approaching : geometry.remainingPageApproaching;

      if (touchViewport.matches && direction > 0 && shouldQueue) {
        queueClosingSnap();
      }

      if (!geometry.visible && !shouldQueue && direction < 0) {
        closingZoneVisible = false;
        syncFrameState();
      }
    };

    const closingObserver = new IntersectionObserver(
      (entries) => {
        closingZoneVisible = entries[0].isIntersecting;
        syncFrameState();
        if (closingZoneVisible && direction > 0) queueClosingSnap();
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );

    closingObserver.observe(footer);

    footer.querySelectorAll('.dh-footer__column').forEach((column) => {
      column.addEventListener('toggle', syncFrameState);
    });

    window.addEventListener('scroll', trackDirection, { passive: true });
    window.addEventListener('touchend', () => {
      const geometry = footerGeometry();
      const shouldSnap = lockedReference ? geometry.approaching : geometry.remainingPageApproaching;
      if (direction > 0 && shouldSnap) queueClosingSnap();
    }, { passive: true });

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', () => {
        const geometry = footerGeometry();
        const shouldSnap = lockedReference ? geometry.approaching : geometry.remainingPageApproaching;
        if (direction > 0 && shouldSnap) snapToClosingFrame();
      }, { passive: true });
    }

    touchViewport.addEventListener('change', () => {
      syncVisibleViewport();
      syncFrameState();
    });
    window.addEventListener('resize', () => {
      syncVisibleViewport();
      syncFrameState();
    }, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncVisibleViewport, { passive: true });
      window.visualViewport.addEventListener('scroll', syncVisibleViewport, { passive: true });
    }

    syncVisibleViewport();
    syncFrameState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalFooterFrame, { once: true });
  } else {
    initGlobalFooterFrame();
  }
})();

/* DREAM HIGH — PRODUCT PURCHASE BRIDGE
   Scope is intentionally limited to the twelve approved custom product preview pages.
   Product presentation, colour switching, size switching and geometry remain untouched. */
(() => {
  const variantMap = {
    'dhi-mt07-preview': { black: 49272022106331, brown: 49272022139099 },
    'dhi-mt12-preview': { black: 49189382521051, brown: 49189382488283 },
    'dhi-mt13-preview': { amber: 49190432473307, 'marino-black': 49190432506075, 'poppy-brown': 49190432538843, 'gaz-black': 49190432571611 },
    'dhi-mt15-preview': { brown: 49272022171867, black: 49272022204635 },
    'dhi-mt16-preview': { black: 49272022401243, 'gaz-brown': 49272022434011, 'poppy-brown': 49272022466779 },
    'dhi-mt17-preview': { tan: 49272022565083, 'marino-black': 49272022597851, 'gaz-black': 49272022630619, navy: 49272022663387, brown: 49272022696155 },
    'dhi-mt19-preview': { brown: 49272022728923, black: 49272022761691 },
    'dhi-mt20-preview': { brown: 49272022794459, black: 49272022827227 },
    'dhi-mt21-preview': { tan: 49272022859995, mblack: 49272022892763, brown: 49272022925531, black: 49272022958299 },
    'dhi-uncc-preview': { tan: 49272022991067, black: 49272023023835, brown: 49272023056603 },
    'dhi-unpp-preview': { tan: 49272023089371, brown: 49272023122139, black: 49272023154907 },
    'dhi-saf-h-preview': {
      '36': 49274760921307,
      '38': 49274760954075,
      '40': 49274760986843,
      '42': 49274761019611,
      '44': 49274761052379
    }
  };

  const resolveVariantId = (root) => {
    const pageKey = Object.keys(variantMap).find((key) => root.classList.contains(key));
    if (!pageKey) return null;

    if (pageKey === 'dhi-saf-h-preview') {
      const selectedSize = root.querySelector('[data-size-choice].is-selected');
      if (!selectedSize) return null;
      return variantMap[pageKey][selectedSize.dataset.sizeChoice] || null;
    }

    const selectedColour = root.querySelector('[data-colour-choice].is-selected');
    if (!selectedColour) return null;
    return variantMap[pageKey][selectedColour.dataset.colourChoice] || null;
  };

  const getShopRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('.dhi-product__add[data-standard-add]');
    const buyButton = event.target.closest('[data-standard-buy] .shopify-payment-button__button');
    const button = addButton || buyButton;
    if (!button) return;

    // Live commerce blocks use Shopify's native product form and payment button.
    // Do not let this legacy bridge intercept or duplicate those actions.
    const liveScope = button.closest('.dhi-product__form');
    if (liveScope && liveScope.querySelector('[data-live-variant-select]')) return;

    const root = button.closest('.dhi-product');
    if (!root) return;

    const variantId = resolveVariantId(root);
    if (!variantId) return;

    const rootUrl = getShopRoot();

    if (buyButton) {
      if (button.dataset.dhiBuying === 'true') return;

      const originalLabel = button.textContent;
      button.dataset.dhiBuying = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Opening checkout…';

      window.location.assign(rootUrl + 'cart/' + variantId + ':1');

      window.setTimeout(() => {
        button.textContent = originalLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.dataset.dhiBuying = 'false';
      }, 2500);
      return;
    }

    if (button.dataset.dhiAdding === 'true') return;

    const originalLabel = button.textContent;
    button.dataset.dhiAdding = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';

    try {
      const response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!response.ok) throw new Error('Add to bag failed');
      window.location.assign(rootUrl + 'cart');
    } catch (error) {
      button.textContent = 'Unable to add';
      window.setTimeout(() => {
        button.textContent = originalLabel;
      }, 1800);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.dataset.dhiAdding = 'false';
    }
  });
})();

/* DREAM HIGH — CART EXPERIENCE
   Presentation only. Shopify continues to own cart contents, quantities and checkout. */
(() => {
  const styleId = 'dhi-cart-luxury-styles';
  const addStyles = () => {
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .cart-template.dhi-cart-luxury{background:#fff;color:#0a0a0a;font-family:"Manrope",Arial,sans-serif}
      .cart-template.dhi-cart-luxury .cart-template__container{max-width:1320px;margin:0 auto;padding-left:clamp(20px,4vw,64px);padding-right:clamp(20px,4vw,64px)}
      .cart-template.dhi-cart-luxury .dhi-cart__intro{padding:clamp(42px,7vw,96px) 0 clamp(28px,4vw,54px);border-bottom:1px solid #F2F0EC}
      .cart-template.dhi-cart-luxury .dhi-cart__eyebrow{margin:0 0 13px;font:600 10px/1.4 "Manrope",Arial,sans-serif;letter-spacing:.18em;text-transform:uppercase;color:#0A0A0A}
      .cart-template.dhi-cart-luxury .cart-template__title{margin:0;font-family:"Cormorant Garamond","Cormorant",Georgia,serif;font-size:clamp(42px,6vw,76px);font-weight:400;line-height:.98;letter-spacing:-.025em;color:#0a0a0a}
      .cart-template.dhi-cart-luxury .dhi-cart__lede{max-width:520px;margin:17px 0 0;font:400 13px/1.7 "Manrope",Arial,sans-serif;color:#0A0A0A}
      .cart-template.dhi-cart-luxury .cart-template__items{margin-top:0}
      .cart-template.dhi-cart-luxury .cart-items__head{padding-top:18px;padding-bottom:18px;border-bottom:1px solid #F2F0EC;color:#0A0A0A;font-size:10px;letter-spacing:.14em;text-transform:uppercase}
      .cart-template.dhi-cart-luxury .cart-items__body{border-bottom:1px solid #F2F0EC}
      .cart-template.dhi-cart-luxury .cart-template__footer{padding-top:clamp(28px,4vw,48px);border-top:0}
      .cart-template.dhi-cart-luxury .cart-footer__subtotal{font-size:14px;letter-spacing:.01em}
      .cart-template.dhi-cart-luxury .cart-footer__subtotal-value{font-weight:600}
      .cart-template.dhi-cart-luxury .cart-template__ctas{margin-top:20px}
      .cart-template.dhi-cart-luxury .cart-footer__button[name="checkout"]{min-height:56px!important;border:1px solid #0a0a0a!important;border-radius:0!important;background:#0a0a0a!important;color:#fff!important;box-shadow:none!important;font:600 12px/1.4 "Manrope",Arial,sans-serif!important;letter-spacing:.14em!important;text-transform:uppercase!important}
      .cart-template.dhi-cart-luxury .cart-footer__button[name="checkout"]:hover{background:#0A0A0A!important;border-color:#0A0A0A!important}
      .cart-template.dhi-cart-luxury .cart-footer__ctas-additional{display:none!important}
      .cart-template.dhi-cart-luxury .dhi-cart__assurance{margin:13px 0 0;color:#0A0A0A;font:400 11px/1.6 "Manrope",Arial,sans-serif;text-align:right}
      .cart-drawer.dhi-cart-drawer-luxury{font-family:"Manrope",Arial,sans-serif}
      .cart-drawer.dhi-cart-drawer-luxury .drawer__title,.cart-drawer.dhi-cart-drawer-luxury .cart-drawer__header-tab-button{font-family:"Cormorant Garamond","Cormorant",Georgia,serif;font-weight:400}
      .cart-drawer.dhi-cart-drawer-luxury .cart-footer__button[name="checkout"]{border-radius:0!important;background:#0a0a0a!important;border-color:#0a0a0a!important;color:#fff!important}
      .cart-drawer.dhi-cart-drawer-luxury .cart-footer__button[href*="/cart"]{border-radius:0!important;background:#fff!important;border:1px solid #0a0a0a!important;color:#0a0a0a!important}
      @media(max-width:767px){
        .cart-template.dhi-cart-luxury .dhi-cart__intro{padding-top:34px;padding-bottom:26px}
        .cart-template.dhi-cart-luxury .cart-template__title{font-size:46px}
        .cart-template.dhi-cart-luxury .cart-items__head{display:none}
        .cart-template.dhi-cart-luxury .dhi-cart__assurance{text-align:left}
      }
    `;
    document.head.appendChild(style);
  };

  const enhanceCart = () => {
    const cart = document.querySelector('.cart-template');
    if (cart && cart.dataset.dhiLuxuryBound !== 'true') {
      cart.dataset.dhiLuxuryBound = 'true';
      cart.classList.add('dhi-cart-luxury');
      const title = cart.querySelector('.cart-template__title');
      if (title) {
        const intro = document.createElement('div');
        intro.className = 'dhi-cart__intro';
        const eyebrow = document.createElement('p');
        eyebrow.className = 'dhi-cart__eyebrow';
        eyebrow.textContent = 'Dream High / The House';
        const lede = document.createElement('p');
        lede.className = 'dhi-cart__lede';
        lede.textContent = 'Review your selection before secure checkout.';
        title.textContent = 'Your Selection';
        title.parentNode.insertBefore(intro, title);
        intro.appendChild(eyebrow);
        intro.appendChild(title);
        intro.appendChild(lede);
      }
      const checkout = cart.querySelector('.cart-footer__button[name="checkout"]');
      if (checkout && !cart.querySelector('.dhi-cart__assurance')) {
        const assurance = document.createElement('p');
        assurance.className = 'dhi-cart__assurance';
        assurance.textContent = 'Continue securely to checkout. Complimentary delivery within India is applied automatically.';
        checkout.closest('.cart-template__ctas')?.insertAdjacentElement('afterend', assurance);
      }
    }

    document.querySelectorAll('.cart-drawer').forEach((drawer) => drawer.classList.add('dhi-cart-drawer-luxury'));
  };

  const init = () => {
    addStyles();
    enhanceCart();
    const observer = new MutationObserver(() => enhanceCart());
    observer.observe(document.body, { childList:true, subtree:true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();

/* DREAM HIGH — MOBILE PRODUCT GALLERY COUNTERS
   Standard preview galleries only. MT07 retains its dedicated counter logic.
   Applicable preview galleries use a stationary overlay outside the horizontal scroller on mobile. */
(() => {
  const anchoredRoots = ':not(*)';
  const stationaryRoots = '.dhi-mt12-preview,.dhi-mt13-preview,.dhi-mt15-preview,.dhi-mt16-preview,.dhi-mt17-preview,.dhi-mt19-preview,.dhi-mt20-preview,.dhi-mt21-preview,.dhi-uncc-preview,.dhi-unpp-preview';

  const initMobileProductGalleryCounters = () => {
    document.querySelectorAll('.dhi-product:not(.dhi-mt07-preview)').forEach((root) => {
      const gallery = root.querySelector('.dhi-product__gallery');
      const counter = root.querySelector('.dhi-product__gallery-count');
      if (!gallery || !counter || gallery.dataset.dhiMobileCounterBound === 'true') return;

      const spans = counter.querySelectorAll('span');
      const current = spans[0];
      const total = spans[spans.length - 1];
      if (!current || !total) return;

      const stationary = root.matches(stationaryRoots);
      const keepAnchored = root.matches(anchoredRoots);
      const galleryColumn = stationary ? gallery.closest('.dhi-product__gallery-column') : null;
      const homeParent = counter.parentNode;
      const homeNext = counter.nextSibling;

      gallery.dataset.dhiMobileCounterBound = 'true';
      let frame = 0;

      const resetStationaryStyles = () => {
        ['position','right','bottom','top','z-index','transform','pointer-events'].forEach((prop) => {
          counter.style.removeProperty(prop);
        });
      };

      const syncStationaryHost = () => {
        if (!stationary || !galleryColumn) return;
        const mobile = window.matchMedia('(max-width:1023px)').matches;

        if (!mobile) {
          if (counter.parentNode !== homeParent) {
            if (homeNext && homeNext.parentNode === homeParent) homeParent.insertBefore(counter, homeNext);
            else homeParent.appendChild(counter);
          }
          resetStationaryStyles();
          return;
        }

        if (counter.parentNode !== galleryColumn) galleryColumn.appendChild(counter);

        counter.style.position = 'absolute';
        counter.style.right = '18px';
        counter.style.bottom = 'auto';
        counter.style.zIndex = '3';
        counter.style.transform = 'none';
        counter.style.pointerEvents = 'none';

        const top = gallery.offsetTop + gallery.clientHeight - counter.offsetHeight - 16;
        counter.style.top = `${Math.max(0, top)}px`;
      };

      const update = () => {
        if (!window.matchMedia('(max-width:1023px)').matches) {
          if (keepAnchored) counter.style.removeProperty('transform');
          return;
        }

        const slides = Array.from(gallery.querySelectorAll('.dhi-product__media')).filter((slide) => {
          return !slide.hidden && window.getComputedStyle(slide).display !== 'none';
        });
        if (!slides.length) return;

        const galleryLeft = gallery.getBoundingClientRect().left;
        let activeIndex = 0;
        let smallestDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - galleryLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activeIndex = index;
          }
        });

        current.textContent = String(activeIndex + 1);
        total.textContent = String(slides.length);

        if (keepAnchored) {
          counter.style.transform = `translate3d(${gallery.scrollLeft}px,0,0)`;
        }
      };

      const queueUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          update();
        });
      };

      const queueLayoutAndUpdate = () => {
        window.requestAnimationFrame(() => {
          syncStationaryHost();
          queueUpdate();
        });
      };

      gallery.addEventListener('scroll', queueUpdate, { passive: true });

      const observer = new MutationObserver(queueLayoutAndUpdate);
      observer.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });

      window.addEventListener('resize', queueLayoutAndUpdate, { passive: true });

      syncStationaryHost();
      queueUpdate();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductGalleryCounters, { once: true });
  } else {
    initMobileProductGalleryCounters();
  }
})();


/* DREAM HIGH — MARKET LOCALIZATION
   Uses Shopify's browsing context suggestion endpoint so Grow-plan visitors
   can enter the appropriate supported market while preserving manual region choices. */
(() => {
  const SUPPORTED = new Set(['CH', 'NO', 'AU', 'NZ']);
  const MANUAL_KEY = 'dhiMarketManualCountry';
  const ATTEMPT_KEY = 'dhiMarketLocalizationAttempted';

  const safeGet = (storage, key) => {
    try { return storage.getItem(key); } catch (error) { return null; }
  };
  const safeSet = (storage, key, value) => {
    try { storage.setItem(key, value); } catch (error) {}
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.js-disclosure-link[data-value]');
    if (!link) return;
    const value = String(link.dataset.value || '').toUpperCase();
    if (value) safeSet(window.localStorage, MANUAL_KEY, value);
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[name="country_code"]');
    if (!select) return;
    const value = String(select.value || '').toUpperCase();
    if (value) safeSet(window.localStorage, MANUAL_KEY, value);
  }, true);

  async function initDreamHighMarketLocalization() {
    if (document.documentElement.hasAttribute('data-dhi-location-access')) return;
    if (!window.Shopify || window.Shopify.designMode) return;

    const currentCountry = String(window.Shopify.country || '').toUpperCase();
    if (SUPPORTED.has(currentCountry)) return;
    if (currentCountry && currentCountry !== 'IN') return;
    if (safeGet(window.localStorage, MANUAL_KEY)) return;
    if (safeGet(window.sessionStorage, ATTEMPT_KEY)) return;

    safeSet(window.sessionStorage, ATTEMPT_KEY, '1');

    const root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
    const language = window.Shopify.language || 'en';
    const url =
      root +
      'browsing_context_suggestions.json?country[enabled]=true' +
      '&country[exclude]=' + encodeURIComponent(currentCountry || 'IN');

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      const detectedCountry = String(
        data &&
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle || ''
      ).toUpperCase();

      if (!SUPPORTED.has(detectedCountry)) return;

      const suggestedCountry = String(
        data &&
        data.suggestions &&
        data.suggestions[0] &&
        data.suggestions[0].parts &&
        data.suggestions[0].parts.country &&
        data.suggestions[0].parts.country.handle || detectedCountry
      ).toUpperCase();

      const targetCountry = SUPPORTED.has(suggestedCountry) ? suggestedCountry : detectedCountry;

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = root + 'localization';
      form.hidden = true;

      const fields = {
        _method: 'PUT',
        country_code: targetCountry,
        language_code: language,
        return_to: window.location.pathname + window.location.search
      };

      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      /* Keep the current market if Shopify localization discovery is unavailable. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDreamHighMarketLocalization, { once: true });
  } else {
    initDreamHighMarketLocalization();
  }
})();
